import styled, { css } from 'styled-components';
import { Box, Heading } from '@bechtel/gds';
export const CommodityMilestoneStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  py: { sm: '450' },
  px: { sm: '500' },
  flexGrow: { sm: 1 },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;
export const PlanErrorHeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    background: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    border: solid 1px ${theme.colors.grey[300]};
    color: ${theme.colors.grey[1000]};
  `}
`;
